import CloseIcon from '@mui/icons-material/Close';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Fab from '@mui/material/Fab';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useGuardActiveEditClose } from '@/components/EditableSectionField/_hooks/useGuardActiveEditClose';
import { useInlineEditContext } from '@/components/EditableSectionField/InlineEditContext';
import { useScrollUpVisible } from '@/components/ScrollUpButton/useScrollUpVisible';
import {
	useTouchEditVisible,
	useToggleTouchEditVisible,
	useHideTouchEditVisible
} from '@/core/store/touchEdit/touchEditSelectors';

import { touchEditToggleButtonStyles as sx } from './TouchEditToggleButton.styles';

export const TouchEditToggleButton = () => {
	const { t } = useTranslation();
	const inlineEditCtx = useInlineEditContext();
	const visible = useTouchEditVisible();
	const toggleVisible = useToggleTouchEditVisible();
	const hideVisible = useHideTouchEditVisible();
	const scrollUpVisible = useScrollUpVisible();
	const closeActiveFieldAndHide = useGuardActiveEditClose('', hideVisible);

	useEffect(() => {
		const mediaQuery = window.matchMedia('(hover: hover)');
		const onChange = (e: MediaQueryListEvent) => {
			if (e.matches) hideVisible();
		};

		mediaQuery.addEventListener('change', onChange);
		return () => mediaQuery.removeEventListener('change', onChange);
	}, [hideVisible]);

	if (!inlineEditCtx) {
		return null;
	}

	const handleClick = () => {
		if (visible) {
			closeActiveFieldAndHide();
			return;
		}

		toggleVisible();
	};

	return (
		<Fab
			onClick={handleClick}
			sx={sx.root(scrollUpVisible)}
			size='small'
			color='primary'
			aria-label={visible ? t('Hide edit controls') : t('Show edit controls')}
			id='touch-edit-toggle-button'
		>
			{visible ? <CloseIcon /> : <EditOutlinedIcon />}
		</Fab>
	);
};
